import { cities, europeanCountries, statesUSA } from "../global/constants";

const CountrySelect = ({
  label = "País",
  register,
  setValue,
  errors,
  countryPath,
  otherCountryPath,
  cityPath,
  selectedCountry,
  onCountryChange,
}) => {
  return (
    <div className="c-form__row c-form__row--2col">
      <label className="c-form__group c-form__col">
        <span className="c-form__label">{label}</span>
        <span className="c-form__select">
          <select
            className="c-form__input"
            name="country"
            id="country"
            onChange={(e) => {
              onCountryChange && onCountryChange(e.target.value);
              setValue(otherCountryPath, "");
              setValue(cityPath, "");
            }}
            defaultValue={selectedCountry || "uruguay"}
            {...register(countryPath)}
          >
            <option value="uruguay">Uruguay</option>
            <option value="usa">Estados Unidos</option>
            <option value="europa">Europa</option>
            <option value="otro">Otro...</option>
          </select>
        </span>
      </label>

      {selectedCountry === "otro" && (
        <label className="c-form__group c-form__col">
          <span className="c-form__label">Indique cual</span>
          <input
            type="text"
            name="otherCountry"
            className="c-form__input"
            placeholder="Ingresa el país..."
            {...register(otherCountryPath, { required: true })}
          />
          {errors?.[otherCountryPath]?.type === "required" && (
            <span className="c-form__error">Este campo es obligatorio</span>
          )}
        </label>
      )}

      {selectedCountry === "uruguay" && (
        <label className="c-form__group c-form__col">
          <span className="c-form__label">Departamento</span>
          <span className="c-form__select">
            <select
              className="c-form__input"
              name="city"
              id="city"
              defaultValue=""
              {...register(cityPath, { required: true })}
            >
              <option value="" disabled>
                Seleccione un departamento
              </option>
              {cities &&
                cities.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.name}
                  </option>
                ))}
            </select>
          </span>
          {errors?.[cityPath]?.type === "required" && (
            <span className="c-form__error">Este campo es obligatorio</span>
          )}
        </label>
      )}

      {selectedCountry === "usa" && (
        <label className="c-form__group c-form__col">
          <span className="c-form__label">Estado</span>
          <span className="c-form__select">
            <select
              className="c-form__input"
              name="city"
              id="city"
              defaultValue=""
              {...register(cityPath, { required: true })}
            >
              <option value="" disabled>
                Seleccione un estado
              </option>
              {statesUSA &&
                statesUSA.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.name}
                  </option>
                ))}
            </select>
          </span>
          {errors?.[cityPath]?.type === "required" && (
            <span className="c-form__error">Este campo es obligatorio</span>
          )}
        </label>
      )}

      {selectedCountry === "europa" && (
        <label className="c-form__group c-form__col">
          <span className="c-form__label">País</span>
          <span className="c-form__select">
            <select
              className="c-form__input"
              name="city"
              id="city"
              {...register(cityPath, { required: true })}
            >
              <option value="" disabled>
                Seleccione un pais
              </option>
              {europeanCountries &&
                europeanCountries.map((country) => (
                  <option key={country.id} value={country.id}>
                    {country.name}
                  </option>
                ))}
            </select>
          </span>
        </label>
      )}
    </div>
  );
};

export default CountrySelect;
